// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3_8pL","row":"Node_row__2HlEW","label":"Node_label__q4h1R","footer":"Node_footer__1rbnv"};